import { DescriptionOutlinedIcon, NoRowsOverlay } from '@shared/components';

import { CreateQConfigButton } from '../../containers';

export function QConfigListNoRowsOverlay() {
  return (
    <NoRowsOverlay
      icon={DescriptionOutlinedIcon}
      title='ยังไม่มี QConfig'
      description='คลิกที่ปุ่ม “+ Create QConfig” เพื่อเริ่มสร้าง'
      action={<CreateQConfigButton variant='outlined' size='large' />}
    />
  );
}
